import { openChatProposal } from "@/features/portfolio-analysis/lib/chat-proposal-store";
import { cardChoice } from "@/features/intelligence/lib/card-choice";
import type { HandlerOutcome } from "@/features/intelligence/lib/frontend-tool-run";
import type { PreparePortfolioProposalArgs } from "@/features/intelligence/lib/frontend-tools";
import {
  choiceResult,
  searchedInstead,
  shownResult,
} from "@/features/intelligence/lib/tool-result";

export async function preparePortfolioProposal(
  { seed, ignored, notAnId }: PreparePortfolioProposalArgs,
  toolCallId: string,
): Promise<HandlerOutcome> {
  openChatProposal(toolCallId, seed);
  const choice = await cardChoice(seed, true, toolCallId);
  if (choice.kind !== "chosen") {
    return choiceResult(
      choice,
      searchedInstead(
        "A portfolio-proposal card is in the chat. Once the client and the portfolio are " +
          "chosen, it opens Kundkortet › Analys on that portfolio by itself and starts " +
          `Portföljanalys there. ${NOTHING_YET}`,
        seed,
        notAnId,
      ),
      GOES_NOWHERE,
      ignored,
      "the client or the portfolio",
    );
  }
  return shownResult(
    searchedInstead(
      "A portfolio-proposal card is shown in the chat. It has found the client and the " +
        "portfolio, so it opens Kundkortet › Analys on that portfolio by itself, normally " +
        `before the advisor reads your reply, and starts Portföljanalys there. ${AT_MOST_ONE}`,
      seed,
      notAnId,
    ),
    `${ADVISOR_STEPS}; ${GOES_NOWHERE}`,
    ignored,
  );
}

const ADVISOR_STEPS =
  "Portföljanalys is started there for the portfolio, and the advisor picks a point on the " +
  "frontier and creates the proposal with Skapa portföljförslag";

const REUSES_OR_OPTIMISES =
  "Portföljanalys reuses today's optimisation of the portfolio when it still fits the " +
  "holdings, and then nothing runs in Quant; otherwise it runs one optimisation in Quant, " +
  "which can take a minute and is stored and cannot be deleted. last-optimize answers 404 for " +
  "a portfolio once a point has been picked on it (LF-1461), so it can optimise again on a " +
  "portfolio already optimised today. Which of the two happens is settled after this result, " +
  "and you are not told: say that it optimises in Quant when there is no optimisation from " +
  "today, and if the advisor asks whether you optimised, say that Portföljanalys either " +
  "reused today's optimisation or ran one, that you cannot see which, and never that nothing " +
  "ran in Quant";

const NOTHING_YET =
  `No proposal has been created and nothing has run in Quant on this call yet: ${ADVISOR_STEPS}. ` +
  `Once the portfolio is chosen, ${REUSES_OR_OPTIMISES}`;

const AT_MOST_ONE =
  "No proposal has been created, and this call runs at most one optimisation in Quant and no " +
  `analysis: ${ADVISOR_STEPS}. ${REUSES_OR_OPTIMISES}`;

const GOES_NOWHERE =
  "do not tell the advisor to go to Kundkortet or any other page, since the card opens it, " +
  "do not say a frontier or a proposal exists, and do not optimise or create a proposal " +
  "yourself";
